import { render, staticRenderFns } from "./applicationStartUp.vue?vue&type=template&id=b79d0a3a&scoped=true&"
import script from "./applicationStartUp.vue?vue&type=script&lang=js&"
export * from "./applicationStartUp.vue?vue&type=script&lang=js&"
import style0 from "./applicationStartUp.vue?vue&type=style&index=0&id=b79d0a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79d0a3a",
  null
  
)

export default component.exports